import { createClient } from '@supabase/supabase-js'
import { Database } from './supabase.types'
import { env } from '@/env'

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)
